import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { MenuItem, TextField, Typography } from "../../components/ui-v2";
import { GALLERY_WINDOW_Z_INDEX } from "../gallery/GalleryWindow";
import { TextureMap } from "./TextureMap";
import type { MaterialModeOption } from "./types";
import { useModelViewerSettings } from "./useModelViewerSettings";
const MATERIAL_OPTIONS: MaterialModeOption[] = [
  "textured",
  "plain",
  "wireframe",
] as const;

const MaterialOptionToNameMap = new Map<MaterialModeOption, string>([
  ["textured", "Textured"],
  ["plain", "Untextured"],
  ["wireframe", "Wireframe"],
]);

const Container = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: `0 ${theme.spacing(3)}`,
  paddingBottom: theme.spacing(3),
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

interface MaterialsControlsProps {
  url: string;
}

export const MaterialsControls = (props: MaterialsControlsProps) => {
  const { url } = props;

  const { materialMode, setMaterialMode } = useModelViewerSettings();

  const handleChangeMaterialMode = (event: any) => {
    setMaterialMode(event.target.value as MaterialModeOption);
  };

  return (
    <Container gap={3}>
      <HeaderContainer>
        <Typography color="secondary.2" variant="regular">
          Materials
        </Typography>
      </HeaderContainer>
      <Stack
        direction="column"
        sx={{
          alignItems: "flex-start",
          gap: 1,
        }}
      >
        <Typography color="secondary.2" variant="small">
          Texturing
        </Typography>
        <TextField
          value={materialMode}
          onChange={handleChangeMaterialMode}
          select
          fullWidth
          SelectProps={{
            MenuProps: {
              sx: {
                zIndex: GALLERY_WINDOW_Z_INDEX + 1,
              },
            },
          }}
          InputProps={{
            sx: {
              "&& .MuiSelect-select": {
                pr: 0,
              },
            },
          }}
        >
          {MATERIAL_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {MaterialOptionToNameMap.get(option)}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
      <Stack
        sx={{
          gap: 1,
        }}
      >
        <Typography color="secondary.2" variant="small">
          Texture Map
        </Typography>
        <TextureMap url={url} />
      </Stack>
    </Container>
  );
};
